"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDaytripEmail = void 0;
const class_validator_1 = require("class-validator");
/**
 * Checks if the email contains @mydaytrip.com or @ondaytrip.com
 */
const isDaytripEmail = (email) => {
    if (!(0, class_validator_1.isEmail)(email)) {
        return false;
    }
    const emailLowerCase = email.toLowerCase();
    if (emailLowerCase.match(/@mydaytrip\.com$/) ||
        emailLowerCase.match(/@ondaytrip\.com$/) ||
        emailLowerCase.match(/@daytrip\.com$/)) {
        return true;
    }
    return false;
};
exports.isDaytripEmail = isDaytripEmail;
//# sourceMappingURL=is-daytrip-email.js.map